<template>
  <div>
    <Header />
    <div class="pt80">
      <div id="section2">
        <div class="container">
          <div>
            <div class="th2">
              {{ newData.tit }}
            </div>
            <div class="th3">
              {{ newData.year }}-{{ newData.month }}-{{ newData.day }}
            </div>
            <div class="txt">
              {{ newData.txt }}
            </div>
            <div v-if="newData.video" style="margin: 20px 0 10px;">
              <video width="528px" controls autoplay>
                <source :src="require(`@/assets/${newData.video}`)" type="video/mp4" />
              </video>
            </div>
            <img :src="require(`@/assets/${newData.pic}`)" width="528px" />
            <div
              class="txt"
              v-for="(t, i) in newData.txtJson"
              :key="i"
              style="margin-bottom: 29px"
            >
              {{ t }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import "@/assets/css/animate.css";
import news from "./newsJson.js";
export default {
  name: "news",
  components: { Header, Footer },
  data() {
    return {
      newData: {},
    };
  },
  created() {
    console.log(this.$route.query.i);
    this.newData = news[this.$route.query.i];
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.pt80 {
  padding-top: 80px;
}

.container {
  padding: 0;
}

#section2 {
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  .container {
    padding: 52px 40px 200px;
    > div {
      width: 880px;
      text-align: center;
    }
  }
  img {
    margin: 12px auto 36px;
    text-align: center;
    border-radius: 10px;
  }
  .th2 {
    margin-top: 12px;
    font-weight: 700;
    font-size: 36px;
    color: #3e3e3e;
    line-height: 43px;
  }
  .th3 {
    margin: 12px 0;
    font-weight: 400;
    font-size: 24px;
    color: rgba(158, 158, 158, 0.37);
    line-height: 36px;
  }
  .txt {
    font-weight: 400;
    font-size: 16px;
    color: #9e9e9e;
    line-height: 24px;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newsDetails.vue